// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--004ba";
export var screen1__btn = "style-module--screen1__btn--8439e";
export var screen1__text = "style-module--screen1__text--e69a9";
export var screen1__title = "style-module--screen1__title--1aa40";